"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function splitContentElementsByDescriptor(inputElements, operator) {
  return inputElements.reduce(function (accumulator, current, index, arr) {
    var currentResult = operator(current);
    var prevIndex = index - 1;
    var prevResult = prevIndex >= 0 && operator(arr[prevIndex]);

    if (currentResult !== prevResult) {
      accumulator.push([current]);
    } else {
      accumulator[accumulator.length - 1].push(current);
    }

    return accumulator;
  }, []);
}

exports.splitContentElementsByDescriptor = splitContentElementsByDescriptor;
var VisualRenderMode;

(function (VisualRenderMode) {
  VisualRenderMode[VisualRenderMode["Unknown"] = 0] = "Unknown";
  VisualRenderMode[VisualRenderMode["Text"] = 1] = "Text";
  VisualRenderMode[VisualRenderMode["Media"] = 2] = "Media";
  VisualRenderMode[VisualRenderMode["TextMedia"] = 3] = "TextMedia";
})(VisualRenderMode = exports.VisualRenderMode || (exports.VisualRenderMode = {}));

function getVisualType(element) {
  var renderMapping = {
    ContentfulText: VisualRenderMode.Text,
    ContentfulTextMedia: VisualRenderMode.TextMedia
  };
  var elementType = element.type();

  if (!renderMapping[elementType]) {
    return VisualRenderMode.Unknown;
  }

  return renderMapping[elementType];
}

exports.getVisualType = getVisualType;